import { BaseRouteService } from "./BaseRouteService"; // Zorg ervoor dat je het pad goed hebt ingesteld
import { PlayerService } from "./PlayerService";

interface User {
    playerSessionId: string;
    id: string;
}

interface LoginResponse {
    user?: User;
    message?: string;
}

export class AuthService extends BaseRouteService {
    private API_URL = "authentication";

    // ✅ Nieuwe registratiefunctie met postJsonApi
    public async registerUser(username: string, email: string, password: string): Promise<boolean> {
        const playerService: PlayerService = new PlayerService();
        const playerSessionId: string = playerService.getPlayerSessionId();

        const response: { success: boolean } = await this.postJsonApi<{ success: boolean }, { username: string; email: string; password: string; playerSessionId: string }>(
            `${this.API_URL}/register`,
            { username, email, password, playerSessionId }
        );

        return response.success;
    }

    // ✅ Nieuwe loginfunctie met postJsonApi
    public async loginUser(username: string, password: string): Promise<{ success: boolean; message?: string }> {
        try {
            const response: LoginResponse = await this.postJsonApi<LoginResponse, { username: string; password: string }>(
                `${this.API_URL}/login`,
                { username, password }
            );

            if (!response.user) {
                return { success: false, message: response.message || "Login mislukt." };
            }

            // ✅ Controleer of de playerSessionId bestaat in de response en sla deze op in localStorage
            if (response.user.playerSessionId) {
                localStorage.setItem("userId", String(response.user.id));
                localStorage.setItem("playerSessionId", String(response.user.playerSessionId));
                localStorage.setItem("isLoggedIn", "true"); // Markeer als ingelogd
                console.log("PlayerSessionId en login-status opgeslagen:", response.user.playerSessionId);
            }

            return { success: true };
        }
        catch (error) {
            console.error("Fout bij inloggen:", error);
            return { success: false, message: "Er is een fout opgetreden bij het inloggen." };
        }
    }

    // ✅ Controleer of gebruikersnaam al in gebruik is met postJsonApi
    public async checkUsernameExists(username: string): Promise<boolean> {
        const response: { success: boolean } = await this.postJsonApi<{ success: boolean }, { username: string }>(
            `${this.API_URL}/check-username`,
            { username }
        );

        return response.success;
    }

    // ✅ Controleer of e-mail al in gebruik is met postJsonApi
    public async checkEmailExists(email: string): Promise<boolean> {
        const response: { success: boolean } = await this.postJsonApi<{ success: boolean }, { email: string }>(
            `${this.API_URL}/check-email`,
            { email }
        );

        return response.success;
    }
}

// import { PlayerService } from "./PlayerService";

// export class AuthService {
//     private API_URL = "http://localhost:3001/authentication";

//     public async registerUser(username: string, email: string, password: string): Promise<boolean> {
//         const playerService: PlayerService = new PlayerService();
//         const playerSessionId: string = playerService.getPlayerSessionId();
//         const response: Response = await fetch(`${this.API_URL}/register`, {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({ username, email, password, playerSessionId }),
//         });

//         return response.ok;
//     }

//     public async loginUser(username: string, password: string): Promise<{ success: boolean; message?: string }> {
//         try {
//             const response: Response = await fetch(`${this.API_URL}/login`, {
//                 method: "POST",
//                 headers: { "Content-Type": "application/json" },
//                 body: JSON.stringify({ username, password }),
//             });

//             const data = await response.json();

//             if (!response.ok) {
//                 return { success: false, message: data.message || "Login mislukt." };
//             }

//             // ✅ Controleer of de playerSessionId bestaat in de response en sla deze op in localStorage
//             if (data.user && data.user.playerSessionId) {
//                 localStorage.setItem("userId", data.user.id);
//                 localStorage.setItem("playerSessionId", data.user.playerSessionId);
//                 localStorage.setItem("isLoggedIn", "true"); // Markeer als ingelogd
//                 console.log("PlayerSessionId en login-status opgeslagen:", data.user.playerSessionId);
//             }

//             return { success: true };
//         }
//         catch (error) {
//             console.error("Fout bij inloggen:", error);
//             return { success: false, message: "Er is een fout opgetreden bij het inloggen." };
//         }
//     }

//     // ✅ Controleer of gebruikersnaam al in gebruik is
//     public async checkUsernameExists(username: string): Promise<boolean> {
//         const response: Response = await fetch(`${this.API_URL}/check-username`, {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({ username }),
//         });

//         return response.ok;
//     }

//     // ✅ Controleer of e-mail al in gebruik is
//     public async checkEmailExists(email: string): Promise<boolean> {
//         const response: Response = await fetch(`${this.API_URL}/check-email`, {
//             method: "POST",
//             headers: { "Content-Type": "application/json" },
//             body: JSON.stringify({ email }),
//         });

//         return response.ok;
//     }
// }
